import type { View } from "@/types/workspace";
import {
  IconBraces,
  IconChartBar,
  IconChartDonut2,
  IconMap,
  IconRouteSquare,
  IconTable,
} from "@tabler/icons-react";

// Note: Labels and tooltips are now translated in WorkspaceHeader
// This config only provides the structure and icons
export const views: Record<string, View & { disabled?: boolean }> = {
  map: {
    id: "map",
    label: "Map", // Will be translated in component
    icon: IconMap,
    tooltip: "Map view", // Will be translated in component
    disabled: false,
  },
  table: {
    id: "table",
    label: "Table", // Will be translated in component
    icon: IconTable,
    tooltip: "Table view", // Will be translated in component
    disabled: false,
  },
  json: {
    id: "json",
    label: "Json", // Will be translated in component
    icon: IconBraces,
    tooltip: "Json view", // Will be translated in component
    disabled: false,
  },
  diagram: {
    id: "diagram",
    label: "Diagram", // Will be translated in component
    icon: IconChartBar,
    tooltip: "Diagram view", // Will be translated in component
    disabled: true,
  },
  flow: {
    id: "flow",
    label: "Flow", // Will be translated in component
    icon: IconRouteSquare,
    tooltip: "Flow view", // Will be translated in component
    disabled: true,
  },
  chart: {
    id: "chart",
    label: "Chart", // Will be translated in component
    icon: IconChartDonut2,
    tooltip: "Chart view", // Will be translated in component
    disabled: true,
  },
};
